import React from "react";

import {
    ContactUsBanner,
    ContactUsTabWidget,
    ContactUsMainAddressWidget,
} from "pageComponents/contact-us";

import SEO from "components/seo";

import Layout from "components/Layout/Layout";
const ContactUs = () => (
    <Layout>
        <SEO
            title="PhonePe - Contact Us"
            description="Ask us anything, we’re here to help you! Get help for issues with PhonePe payments, pending payments, failed payments &amp; more. Get support for onboarding as a PhonePe merchant and using PhonePe for your business. Report frauds and suspicious activity on your PhonePe account on this page."
            url="https://www.phonepe.com/contact-us/"
        />
        <ContactUsBanner />
        <ContactUsTabWidget />
        <ContactUsMainAddressWidget />
    </Layout>
);

export default ContactUs;
